import { SettingConst } from '../../types';

/**
 * Enable Insider Free Shiping Threshold for non-enrolled Insiders
 */
export const INSIDER_THRESHOLD_FOR_NON_INSIDERS_ENABLED_230130 =
  'INSIDER_THRESHOLD_FOR_NON_INSIDERS_ENABLED_230130' as SettingConst<
    'INSIDER_THRESHOLD_FOR_NON_INSIDERS_ENABLED_230130',
    boolean,
    'RETAILER'
  >;
